import classNames from 'classnames'
import { ButtonRoundedSm } from './ButtonRoundedSm'

const BUTTON_ROUNDED_WITH_ICON_ROUND_STYLES_SM =
  'h-[32px] rounded-full pl-3 pr-1 w-auto grow min-w-[120px] jost-light text-[0.9em] disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-between gap-[8px]'

const buttonRoundedIconRoundStylesSm = (bg: string) =>
  classNames(bg, 'flex items-center justify-center rounded-full h-[22px] w-[22px]')

interface IProps {
  type: 'button' | 'submit' | 'div'
  text: string
  className?: string
  iconContainerClassName?: string
  icon: any
  disabled?: boolean
  callback?: (e: any) => void
}

export const ButtonRoundedWithIcon: React.FC<IProps> = ({ type, text, className, iconContainerClassName, icon, disabled, callback }) => {
  return (
    <ButtonRoundedSm
      type={type}
      text={text}
      icon={icon}
      iconRight
      className={classNames(BUTTON_ROUNDED_WITH_ICON_ROUND_STYLES_SM, className)}
      iconContainerClassName={buttonRoundedIconRoundStylesSm(iconContainerClassName || '')}
      callback={callback}
    />
  )
}
